import { Component, ElementRef, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, PLATFORM_ID, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiService } from '../../shared/services/apiService.service';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviourSubjectService } from 'src/app/shared/services/behaviour-subject.service';
import { isPlatformBrowser } from '@angular/common';
import { NgForm } from '@angular/forms';
import { ConfLobControlService } from '../../configurator-app/Conf-Shared/Services/conf-lob-service/conf-lob-control.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StoreVariableService } from '../store-variable.service';
@Component({
  selector: 'app-advance-smart-select',
  templateUrl: './advance-smart-select.component.html',
  styleUrls: ['./advance-smart-select.component.scss']
})
export class AdvanceSmartSelectComponent implements OnInit, OnDestroy {
  @Input() ProductListingData: any
  @Input() level3Image: any
  @Input() productPriceForEMi: any;
  @Input() level3Datas: any;
  @Input() breadCrumbData: any
  Postdata_: {};
  productDetailsData: any = {};
  tooltipOpen = false;
  SearchValue: any;
  tooltipOpenBrt = false;
  @ViewChild('btnClose') btnClose!: ElementRef;
  annualKmsArr: any = [
    {
      title: '50',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '100',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '150',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '200',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '250',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '300',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '350',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '400',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '450',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '500',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '550',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '600',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '650',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '700',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '750',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '800',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '850',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '900',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '950',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1000',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1050',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1100',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1150',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1200',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1250',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1300',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1350',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1400',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1450',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1500',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1550',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1600',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1650',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1700',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1750',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1800',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1850',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1900',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '1950',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2000',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2050',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2100',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2150',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2200',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2250',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2300',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2350',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2400',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2450',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2500',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2550',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2600',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2650',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2700',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2750',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2800',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2850',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2900',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '2950',
      isAdded: false,
      type: 'Annual Kms',
    },
    {
      title: '3000',
      isAdded: false,
      type: 'Annual Kms',
    }
  ];
  brt_data: any;
  brtEstimateTotalEarningSign: string;
  @Output() isBrtPriceBreakUpVisibleToSummary = new EventEmitter<boolean>();
  sharePostdatetime: Subscription = new Subscription();
  isBrtDetailsVisible: boolean = false;
  brtEstimateTotalEarning: any;

  range_Array: any = [0, 20, 30, 40, 50, 60, 70, 80, 90, 100]
  range_Array_special: any = [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20]

  tenureInMonths: any = [
    12, 24, 36, 48, 60, 72, 84
  ]
  selectedTenure: any;
  isTenureDropDownClicked: boolean = false;

  actualLoadCarryingRange: any = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  selectedActualLoadCarrying: any;

  ltvChassisRange: any = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  selectedLtvChassis: any

  ltvBodyRange: any = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  selectedLtvBody: any

  financeChargeRange: any = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  selectedFinanceCharge: any;

  annualDepreciationRange: any = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  selectedAnnualDepreciation: any;

  numOfPassengerPerTripRange: any = [10, 20, 30, 40, 50, 60, 70, 80, 90, 100];
  selectedNumOfPassengerPerTrip: number = 0;

  actualLoadCarryingChangeHandler(event: any) {
    this.selectedActualLoadCarrying = event.target.value
  }

  ltvChassisChangeHandler(event: any) {
    this.selectedLtvChassis = event.target.value
  }
  ltvBodyChangeHandler(event: any) {
    this.selectedLtvBody = event.target.value
  }
  financeChargeChangehandler(event: any) {
    this.selectedFinanceCharge = event.target.value
  }
  annualDepreciationChangeHandler(event: any) {
    this.selectedAnnualDepreciation = event.target.value
  }
  numOfPassengerPerTripChangeHandler(event: any) {
    this.selectedNumOfPassengerPerTrip = this.numOfPassengerPerTripRange[event.target.value]
  }

range_obj: any = {};
processData(event: any, name: any) {
  let index = this.BRT_FORM_FIELDS.findIndex((x: { label: string; }) => x.label === name);
  this.BRT_FORM_FIELDS[index].value = event.target.value
  this.range_obj[this.BRT_FORM_FIELDS[index].label] = event.target.value
}

  BRT_FORM: any = {
    "HCV Cargo": [
      {
        label: "Freight Rate",
        type: "input_decimal",
        unit: "(₹/T-Km)",
        tooltip: {
          enable: false,
          content: ""
        },
        disable: false,
        hide: false,
        isValid: undefined

      },
      {
        label: "Actual Load Carrying",
        type: "range",
        unit: "Tons",
        tooltip: {
          enable: false,
          content: "",
          isValid: undefined
        },
        rangeArray: this.actualLoadCarryingRange,
        rangeChangeHandler: this.actualLoadCarryingChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "No. of trips per month",
        type: "input",
        unit: "",
        tooltip: {
          enable: true,
          content: "Total trips done in a month"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Kms per trip",
        type: "meter",
        unit: "kms",
        tooltip: {
          enable: true,
          content: "Distance travelled in each trip  (trip means one to and fro movement)"
        }
        , hide: false,
        isValid: undefined
      },
      {
        label: "Body Price",
        type: "input",
        unit: "₹",
        tooltip: {
          enable: true,
          content: "Cost of the body building done externally."
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "LTV (Loan to Value) Chassis",
        type: "range",
        unit: "%",
        tooltip: {
          enable: true,
          content: "percentage of the vehilce price (purchased from TATA) taken as loan"
        },
        rangeArray: this.ltvChassisRange,
        rangeChangeHandler: this.ltvChassisChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "LTV (Loan to Value) Body",
        type: "range",
        unit: "%",
        tooltip: {
          enable: true,
          content: "percentage of the external body building cost taken as loan"
        },
        rangeArray: this.ltvBodyRange,
        rangeChangeHandler: this.ltvBodyChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "Finance Charge(IRR)",
        type: "range_decimal",
        unit: "%",
        tooltip: {
          enable: true,
          content: `Annual fixed rate of interest charged by the financer`
        },
        rangeArray: this.financeChargeRange,
        rangeChangeHandler: this.financeChargeChangehandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "Loan Tenure in months",
        type: "dropdown",
        unit: "",
        tooltip: {
          enable: true,
          content: "Loan tenure in months"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Avg. Fuel Price Per L",
        type: "input",
        unit: "₹",
        tooltip: {
          enable: true,
          content: "Fuel price in Rupees per Litre"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Annual depreciation rate",
        type: "range_decimal",
        unit: "%",
        tooltip: {
          enable: true,
          content: `Annual rate of depreciation of vehicle value.`
        },
        rangeArray: this.annualDepreciationRange,
        rangeChangeHandler: this.annualDepreciationChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
    ],
    "HCV Const": [
      {
        label: "Freight Rate",
        type: "input_decimal",
        unit: "(₹/T-Hr)",
        tooltip: {
          enable: false,
          content: ""
        },
        disable: false,
        hide: false,
        isValid: undefined
      },
      {
        label: "Actual Load Carrying",
        type: "range",
        unit: "Tons",
        tooltip: {
          enable: false,
          content: ""
        },
        rangeArray: this.actualLoadCarryingRange,
        rangeChangeHandler: this.actualLoadCarryingChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "No. of trips per month",
        type: "input",
        unit: "",
        tooltip: {
          enable: true,
          content: "Total trips done in a month"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Average Lead distance",
        type: "input",
        unit: "Kms",
        tooltip: {
          enable: true,
          content: `DISTANCE BETWEEN LOADING &
        UNLOADING POINT`
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Hrs per trip",
        type: "input",
        unit: "",
        tooltip: {
          enable: false,
          content: ""
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Body Price",
        type: "input",
        unit: "₹",
        tooltip: {
          enable: true,
          content: "Cost of the body building done externally."
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "LTV (Loan to Value) Chassis",
        type: "range",
        unit: "%",
        tooltip: {
          enable: true,
          content: "percentage of the vehilce price (purchased from TATA) taken as loan"
        },
        rangeArray: this.ltvChassisRange,
        rangeChangeHandler: this.ltvChassisChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "LTV (Loan to Value) Body",
        type: "range",
        unit: "%",
        tooltip: {
          enable: true,
          content: "percentage of the external body building cost taken as loan"
        },
        rangeArray: this.ltvBodyRange,
        rangeChangeHandler: this.ltvBodyChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "Finance Charge(IRR)",
        type: "range_decimal",
        unit: "%",
        tooltip: {
          enable: true,
          content: `Annual fixed rate of interest charged by the financer`
        },
        rangeArray: this.financeChargeRange,
        rangeChangeHandler: this.financeChargeChangehandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "Loan Tenure in months",
        type: "dropdown",
        unit: "",
        tooltip: {
          enable: true,
          content: "Loan tenure in months"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Avg. Fuel Price Per L",
        type: "input",
        unit: "₹",
        tooltip: {
          enable: true,
          content: "Fuel price in Rupees per Litre"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Annual depreciation rate",
        type: "range_decimal",
        unit: "%",
        tooltip: {
          enable: true,
          content: `Annual rate of depreciation of vehicle value.`
        },
        rangeArray: this.annualDepreciationRange,
        rangeChangeHandler: this.annualDepreciationChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
    ],
    "ILMCV": [
      {
        label: "Freight Rate",
        type: "input_decimal",
        unit: "(₹/T-Km)",
        tooltip: {
          enable: false,
          content: ""
        },
        disable: false,
        hide: false,
        isValid: undefined
      },
      {
        label: "Actual Load Carrying",
        type: "range",
        unit: "Tons",
        tooltip: {
          enable: false,
          content: "",
          isValid: undefined
        },
        rangeArray: this.actualLoadCarryingRange,
        rangeChangeHandler: this.actualLoadCarryingChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "No. of trips per month",
        type: "input",
        unit: "",
        tooltip: {
          enable: true,
          content: "Total trips done in a month"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Kms per trip",
        type: "meter",
        unit: "kms",
        tooltip: {
          enable: true,
          content: "Distance travelled in each trip  (trip means one to and fro movement)"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Body Price",
        type: "input",
        unit: "₹",
        tooltip: {
          enable: true,
          content: "Cost of the body building done externally."
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "LTV (Loan to Value) Chassis",
        type: "range",
        unit: "%",
        tooltip: {
          enable: true,
          content: "percentage of the vehilce price (purchased from TATA) taken as loan"
        },
        rangeArray: this.ltvChassisRange,
        rangeChangeHandler: this.ltvChassisChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "LTV (Loan to Value) Body",
        type: "range",
        unit: "%",
        tooltip: {
          enable: true,
          content: "percentage of the external body building cost taken as loan"
        },
        rangeArray: this.ltvBodyRange,
        rangeChangeHandler: this.ltvBodyChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "Finance Charge(IRR)",
        type: "range_decimal",
        unit: "%",
        tooltip: {
          enable: true,
          content: `Annual fixed rate of interest charged by the financer`
        },
        rangeArray: this.financeChargeRange,
        rangeChangeHandler: this.financeChargeChangehandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "Loan Tenure in months",
        type: "dropdown",
        unit: "",
        tooltip: {
          enable: true,
          content: "Loan tenure in months"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Avg. Fuel Price Per L",
        type: "input",
        unit: "₹",
        tooltip: {
          enable: true,
          content: "Fuel price in Rupees per Litre"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Annual depreciation rate",
        type: "range_decimal",
        unit: "%",
        tooltip: {
          enable: true,
          content: `Annual rate of depreciation of vehicle value.`
        },
        rangeArray: this.annualDepreciationRange,
        rangeChangeHandler: this.annualDepreciationChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
    ],
    "SCV": [
      {
        label: "Freight Rate",
        type: "input_decimal",
        unit: "(₹/T-Km)",
        tooltip: {
          enable: false,
          content: ""
        },
        disable: false,
        hide: false,
        isValid: undefined
      },
      {
        label: "Actual Load Carrying",
        type: "range",
        unit: "Tons",
        tooltip: {
          enable: false,
          content: ""
        },
        rangeArray: this.actualLoadCarryingRange,
        rangeChangeHandler: this.actualLoadCarryingChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "No. of trips per month",
        type: "input",
        unit: "",
        tooltip: {
          enable: true,
          content: "Total trips done in a month"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Kms per trip",
        type: "meter",
        unit: "kms",
        tooltip: {
          enable: true,
          content: "Distance travelled in each trip  (trip means one to and fro movement)"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Body Price",
        type: "input",
        unit: "₹",
        tooltip: {
          enable: true,
          content: "Cost of the body building done externally."
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "LTV (Loan to Value) Chassis",
        type: "range",
        unit: "%",
        tooltip: {
          enable: true,
          content: "percentage of the vehilce price (purchased from TATA) taken as loan"
        },
        rangeArray: this.ltvChassisRange,
        rangeChangeHandler: this.ltvChassisChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "LTV (Loan to Value) Body",
        type: "range",
        unit: "%",
        tooltip: {
          enable: true,
          content: "percentage of the external body building cost taken as loan"
        },
        rangeArray: this.ltvBodyRange,
        rangeChangeHandler: this.ltvBodyChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "Finance Charge(IRR)",
        type: "range_decimal",
        unit: "%",
        tooltip: {
          enable: true,
          content: `Annual fixed rate of interest charged by the financer`
        },
        rangeArray: this.financeChargeRange,
        rangeChangeHandler: this.financeChargeChangehandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "Loan Tenure in months",
        type: "dropdown",
        unit: "",
        tooltip: {
          enable: true,
          content: "Loan tenure in months"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Avg. Fuel Price Per L",
        type: "input",
        unit: "₹",
        tooltip: {
          enable: true,
          content: "Fuel price in Rupees per Litre"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Annual depreciation rate",
        type: "range_decimal",
        unit: "%",
        tooltip: {
          enable: true,
          content: `Annual rate of depreciation of vehicle value.`
        },
        rangeArray: this.annualDepreciationRange,
        rangeChangeHandler: this.annualDepreciationChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
    ],
    "SCV Cargo Ace EV": [
      {
        label: "Freight Rate",
        type: "input_decimal",
        unit: "(₹/T-Km)",
        tooltip: {
          enable: false,
          content: ""
        },
        disable: false,
        hide: false,
        isValid: undefined
      },
      {
        label: "Actual Load Carrying",
        type: "range",
        unit: "Tons",
        tooltip: {
          enable: false,
          content: ""
        },
        rangeArray: this.actualLoadCarryingRange,
        rangeChangeHandler: this.actualLoadCarryingChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "No. of trips per month",
        type: "input",
        unit: "",
        tooltip: {
          enable: true,
          content: "Total trips done in a month"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Kms per trip",
        type: "meter",
        unit: "kms",
        tooltip: {
          enable: true,
          content: "Distance travelled in each trip  (trip means one to and fro movement)"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Body Price",
        type: "input",
        unit: "₹",
        tooltip: {
          enable: true,
          content: "Cost of the body building done externally."
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "LTV (Loan to Value) Chassis",
        type: "range",
        unit: "%",
        tooltip: {
          enable: true,
          content: "percentage of the vehilce price (purchased from TATA) taken as loan"
        },
        rangeArray: this.ltvChassisRange,
        rangeChangeHandler: this.ltvChassisChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "LTV (Loan to Value) Body",
        type: "range",
        unit: "%",
        tooltip: {
          enable: true,
          content: "percentage of the external body building cost taken as loan"
        },
        rangeArray: this.ltvBodyRange,
        rangeChangeHandler: this.ltvBodyChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "Finance Charge(IRR)",
        type: "range_decimal",
        unit: "%",
        tooltip: {
          enable: true,
          content: `Annual fixed rate of interest charged by the financer`
        },
        rangeArray: this.financeChargeRange,
        rangeChangeHandler: this.financeChargeChangehandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "Loan Tenure in months",
        type: "dropdown",
        unit: "",
        tooltip: {
          enable: true,
          content: "Loan tenure in months"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Avg. Electricity cost per KWh",
        type: "input",
        unit: "₹",
        tooltip: {
          enable: false,
          content: ""
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Annual depreciation rate",
        type: "range_decimal",
        unit: "%",
        tooltip: {
          enable: true,
          content: `Annual rate of depreciation of vehicle value.`
        },
        rangeArray: this.annualDepreciationRange,
        rangeChangeHandler: this.annualDepreciationChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
    ],
    "CVP": [
      {
        label: "Earning per seat per trip",
        type: "input",
        unit: "(₹/Trip)",
        tooltip: {
          enable: true,
          content: "Average price charged to customer for each seat in each trip (trip means one to and fro movement)"
        },
        disable: false,
        hide: false,
        isValid: undefined
      },
      {
        label: "Number of passengers per trip",
        type: "range",
        unit: "",
        tooltip: {
          enable: true,
          content: "Average number of passengers in each trip (trip means one to and fro movement)"
        },
        rangeArray: this.numOfPassengerPerTripRange,
        rangeChangeHandler: this.numOfPassengerPerTripChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "No. of trips per month",
        type: "input",
        unit: "",
        tooltip: {
          enable: true,
          content: "Total trips done in a month"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Kms per trip",
        type: "meter",
        unit: "kms",
        tooltip: {
          enable: true,
          content: "Distance travelled in each trip  (trip means one to and fro movement)"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Body Price",
        type: "input",
        unit: "₹",
        tooltip: {
          enable: true,
          content: "Cost of the body building done externally."
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "LTV (Loan to Value) Chassis",
        type: "range",
        unit: "%",
        tooltip: {
          enable: true,
          content: "percentage of the vehilce price (purchased from TATA) taken as loan"
        },
        rangeArray: this.ltvChassisRange,
        rangeChangeHandler: this.ltvChassisChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "LTV (Loan to Value) Body",
        type: "range",
        unit: "%",
        tooltip: {
          enable: true,
          content: "percentage of the external body building cost taken as loan"
        },
        rangeArray: this.ltvBodyRange,
        rangeChangeHandler: this.ltvBodyChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "Finance Charge(IRR)",
        type: "range_decimal",
        unit: "%",
        tooltip: {
          enable: true,
          content: `Annual fixed rate of interest charged by the financer`
        },
        rangeArray: this.financeChargeRange,
        rangeChangeHandler: this.financeChargeChangehandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "Loan Tenure in months",
        type: "dropdown",
        unit: "",
        tooltip: {
          enable: true,
          content: "Loan tenure in months"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Avg. Fuel Price Per L",
        type: "input",
        unit: "₹",
        tooltip: {
          enable: true,
          content: "Fuel price in Rupees per Litre"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Annual depreciation rate",
        type: "range_decimal",
        unit: "%",
        tooltip: {
          enable: true,
          content: `Annual rate of depreciation of vehicle value.`
        },
        rangeArray: this.annualDepreciationRange,
        rangeChangeHandler: this.annualDepreciationChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
    ],
    "CVP_MAGIC_WINGER": [
      {
        label: "Earning per seat per Km",
        type: "input",
        unit: "(₹/Trip)",
        tooltip: {
          enable: true,
          content: "Average price charged to customer for each seat in each trip (trip means one to and fro movement)"
        },
        disable: false,
        hide: false,
        isValid: undefined
      },
      {
        label: "Number of passengers per trip",
        type: "range",
        unit: "",
        tooltip: {
          enable: true,
          content: "Average number of passengers in each trip (trip means one to and fro movement)"
        },
        rangeArray: this.numOfPassengerPerTripRange,
        rangeChangeHandler: this.numOfPassengerPerTripChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "No. of trips per month",
        type: "input",
        unit: "",
        tooltip: {
          enable: true,
          content: "Total trips done in a month"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Kms per trip",
        type: "meter",
        unit: "kms",
        tooltip: {
          enable: true,
          content: "Distance travelled in each trip  (trip means one to and fro movement)"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Body Price",
        type: "input",
        unit: "₹",
        tooltip: {
          enable: true,
          content: "Cost of the body building done externally."
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "LTV (Loan to Value) Chassis",
        type: "range",
        unit: "%",
        tooltip: {
          enable: true,
          content: "percentage of the vehilce price (purchased from TATA) taken as loan"
        },
        rangeArray: this.ltvChassisRange,
        rangeChangeHandler: this.ltvChassisChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "LTV (Loan to Value) Body",
        type: "range",
        unit: "%",
        tooltip: {
          enable: true,
          content: "percentage of the external body building cost taken as loan"
        },
        rangeArray: this.ltvBodyRange,
        rangeChangeHandler: this.ltvBodyChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "Finance Charge(IRR)",
        type: "range_decimal",
        unit: "%",
        tooltip: {
          enable: true,
          content: `Annual fixed rate of interest charged by the financer`
        },
        rangeArray: this.financeChargeRange,
        rangeChangeHandler: this.financeChargeChangehandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
      {
        label: "Loan Tenure in months",
        type: "dropdown",
        unit: "",
        tooltip: {
          enable: true,
          content: "Loan tenure in months"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Avg. Fuel Price Per L",
        type: "input",
        unit: "₹",
        tooltip: {
          enable: true,
          content: "Fuel price in Rupees per Litre"
        },
        hide: false,
        isValid: undefined
      },
      {
        label: "Annual depreciation rate",
        type: "range_decimal",
        unit: "%",
        tooltip: {
          enable: true,
          content: `Annual rate of depreciation of vehicle value.`,
          isValid: undefined
        },
        rangeArray: this.annualDepreciationRange,
        rangeChangeHandler: this.annualDepreciationChangeHandler,
        value: 0,
        hide: false,
        isValid: undefined
      },
    ]
  }
  brtViewDetailsData: any;
  brtForm: any
  leadId: any;
  brtFormFields: any
  closeResult: string;
  showBlock: boolean = false;
  BRT_FORM_FIELDS: any;

  selectedAnnualKms: any;
  currentSelectedAnnualKmsIndex: number = 0;
  annualKmItemLength: any;
  chassisPrice: any;
  alldata: any;
  dummySearchDataList: any;
  level3DataImages: any = []
  constructor(@Inject(PLATFORM_ID) private platformId: Object, private behaviourservice: BehaviourSubjectService, private ApiService: ApiService, private storeservice: StoreVariableService, private toastrService: ToastrService, private router: Router, private _dataLobService: ConfLobControlService, private modalservice: NgbModal, private route: ActivatedRoute) { }
  ngOnDestroy(): void {
    this.storeservice.isclick.next(true)
  }
  breadCrumb: {
    l1_actual_name: string,
    l2_actual_name: string,
    l3_actual_name: string,
    l4_actual_name: string,
    filterCount: number,
  };

  featureList: any = [];
  // isBrtLinkVisible: boolean = false;
  result: any = {
    emi: "",
    interest: "",
    total: ""
  }
  userInterest: any = 15;
  downPaymentPrice: any = 0;
  productPrice: any;
  environment1 = environment.s3bucket.url;
  FuelTypeFilter = false;
  CabinTypeFIlter = false;
  DeckLengthFilter = false
  BodyTypeFilter = false;
  FifthFilter = false;
  SixthFilter = false;
  selectedItem: any;
  confAWSUrlStr: any = environment.confAWSurl;
  loanAmountOptions = {
    floor: 100000,
    ceil: 8000000,
  };
  ErrorMsg: boolean = false;
  isBrtLinkVisible: boolean = false;
  brtEstimateTotalEarning_1year: any;
  remi: any = {
    value: 15
  }
  level3data: any[] = [];
  userYear: any = 5;
  userMonths: any = 1;
  temi: any = {
    value: 5
  }
  vc_number: any;
  smartFilter: any = [];
  sub: Subscription = new Subscription();
  level2Data: any = [];

  selectedFilters: any = [];
  json: Input1 = {
    deck_length: null,
    cabin_type: null,
    wheels: null,
    feature_premium: null,
    tyre_type: null,
    color: null,
    deck_type: null,
    no_seats: null,
    brand: null,
    air_conditioning: null,
    fuel_type: null,
    body_type: null,
    roof_type: null,
    sleeping_option: null,
    body_option: null,
    tonnage: null,
    engine_power: null,
    body_size: null,
    suspension_type: null,
    engine_type: null,
    colour: null,
    ventilation: null,
    wheelbase: null,
    payload: null,
    wheel_drive: null,
    engine: null,
    RMC_Drum_Size: null
  }
  id: any;
  val: any;
  val2: any;
  level2name: any;
  FilterCount: Input1 = {
    deck_length: null,
    cabin_type: null,
    wheels: null,
    feature_premium: null,
    tyre_type: null,
    color: null,
    deck_type: null,
    no_seats: null,
    brand: null,
    air_conditioning: null,
    fuel_type: null,
    body_type: null,
    roof_type: null,
    sleeping_option: null,
    body_option: null,
    tonnage: null,
    engine_power: null,
    body_size: null,
    suspension_type: null,
    engine_type: null,
    colour: null,
    ventilation: null,
    wheelbase: null,
    payload: null,
    wheel_drive: null,
    engine: null,
    RMC_Drum_Size: null
  };
  selectedLevel2ID: any;
  selectedLevel3ID: any;
  level3DataForward: any = []
  alllevel3: any = []
  level3Id: any;

  @ViewChild('rangeInput') rangeInput: ElementRef;
  userEnteredValue: any = ''
  level3newImages:any;
  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.id = params['level1'];
      this.val = params['level2'];
      this.val2 = params['level3'];
      this.vc_number = params['vcnumber']

      this.SearchValue = params['search']
      this.level2name = params['level2name']
      this.storeservice.vcNumber = this.vc_number
      // Accessing the remaining URL segments
      // this.route.url.subscribe(urlSegments => {
      //   const lastSegmentIndex = urlSegments?.length - 1;
      //   if (urlSegments[lastSegmentIndex].path === 'smart-filter' || urlSegments[lastSegmentIndex].path === 'plp-list') {
      //   } else {
      //     this.storeservice.breadCrumb.l4_actual_name = ''
      //     this.behaviourservice.SearchConsoleFilterCount.next(0);
      //   }
      // });



    });
    this.storeservice.breadCrumb.l1_actual_name = this.id;
    this.storeservice.breadCrumb.l2_actual_name = this.val;
    this.storeservice.breadCrumb.l3_actual_name = this.val2
    this.breadCrumb = this.storeservice.breadCrumb

    // this.productDetailsData=this.ProductListingData
    // this.level3DataImages=this.level3Image
    // this.productPrice=this.productPriceForEMi
    // this.level3data=this.level3Datas
    // this.breadCrumb=this.breadCrumbData
    // this.onsearch(this.id,this.val)
    this.onsearchlevel3(this.id, this.val)

    // setTimeout(() => {
    this.getVehicledetail()

    // }, 500);


    //working code

// this.productDetailsData=this.storeservice.productDetailsData
// this.level3DataImages=this.storeservice.level3DataImages
// this.productPrice=this.storeservice.productPrice
// this.level3data=this.storeservice.level3data
// this.breadCrumb=this.storeservice.breadCrumb
// if (Object.keys(this.productDetailsData)?.length === 0) {
//       this.router.navigate(['advancesearch',this.id,this.val])
// }
// if (this.productDetailsData.vehicle_number) {

//   this.brtcalculatorAPI()
// }
// if (Object.keys(this.productDetailsData)?.length > 0) {
// setTimeout(() => {
// this.getFeature()

// }, 500);
// }
// this.calculateEmi()
  }
  onsearch(level1: any, level2: any) {
    let data = {
      level1: level1,
      level2: level2,
      level3: '',
      search: ''
    };


    this.ApiService.advanceSearch(data).subscribe((res: any) => {
      if (res.success) {
        localStorage.removeItem('l2SearchData');
        localStorage.removeItem('l3SearchData');
        this.onsearchlevel3(this.id, this.val)
        // this.level2Data=res.data.data
        // for (let index = 0; index < this.level2Data?.length; index++) {
        //   this.getonsearchlevel3(this.id,this.val,index)
        // }

        // if (this.level2Data?.length ==1 ) {
        // this.onclickLevel2(this.storeservice.isclickid,'level2')
        // // this.onSearchClick('', '', level2)
        // this.onsearchlevel3(level1,level2)
        // }




        // this.getLevel2Data(this.val)
      }
    })
  }
  onclickLevel2(id, flag) {
    if (flag == 'level2') {
      this.selectedLevel2ID = id;
      this.storeservice.isclickid = id
    }
    else {
      // this.level3data = []
      this.selectedLevel3ID = id;
    }
  }
  getonsearchlevel3(level1: any, level2: any, val: any) {
    let data = {
      level1: level1,
      level2: level2,
      level3: this.level2Data[val]?.l3_actual_name,
      search: ''
    };


    this.ApiService.advanceSearch(data).subscribe((res: any) => {
      if (res.success) {
        this.alllevel3.push(res.data.data)
        const parentIndex = this.alllevel3.findIndex(subArray =>
          subArray.some(item => item.ppl_display_name === this.val2)
        );
        if (parentIndex >= 0) {
          this.onclickLevel2(parentIndex, 'level2')
          // this.onSearchClick('', '', level2)
          this.onsearchlevel3(level1, level2)
        }

      }
    })
  }
  onsearchlevel3(level1: any, level2: any) {
    let data = {
      level1: level1,
      level2: level2,
      level3: this.level2name,
      search: ''
    };
    this.ApiService.advanceSearch(data).subscribe((res: any) => {
      if (res.success) {
        this.level3DataForward = res.data.data;
        this.level3newImages = res.data;


        this.level3data = res.data.data.find(vehicle => vehicle.ppl_display_name === this.val2);

        this.level3DataImages = this.level3data['ppl_image_path']
      }
    })
  }
  validateNumber(event: any) {
    const keyCode = event.keyCode;
    const excludedKeys = [8, 37, 39, 46, 110, 190];
    const value = event.target.value
    const regex = new RegExp(/^\d*\.\d*$/);
    const isDecimalOrNumber = regex.test(value)
    if (isDecimalOrNumber) {
      const valueSplitted = value.split(".");
      if (valueSplitted[1]?.length > 1 && !excludedKeys.includes(keyCode)) {
        event.preventDefault()
      }
    }

    if (!((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode <= 105) || (excludedKeys.includes(keyCode)))) {
      event.preventDefault();
    }
  }

  getVehicledetail() {
    if (isPlatformBrowser(this.platformId)) {
      // this.breadCrumb?.l3_actual_name = val.ppl_actual_name
      // this.breadCrumb?.l3_actual_name = val.ppl_display_name
      let data = {
        vehicle_number: this.vc_number
      }
      this.ApiService.getVehicleDetails(data).subscribe({
        next: (res: any) => {

          if (res.success) {
            // this.level3DataImages=val.ppl_image_path
            // this.displayModal = true;
            this.productDetailsData = res.data


            this.productPrice = this.productDetailsData.price_range
            this.getFeature()
            this.calculateEmi()
            if (this.productDetailsData.vehicle_number) {
              this.brtcalculatorAPI()
            }
            // this.setTrue=true

            // this.selectedFilters = this.level3data.filter((item: any) => item.ppl_display_name == this.breadCrumb?.l3_actual_name)

            if (this.productDetailsData) {

              // this.storeservice.productDetailsData=this.productDetailsData
              // this.storeservice.level3DataImages=this.level3DataImages
              // this.storeservice.level3data=this.level3data
              // this.storeservice.productPrice=this.productPrice
              // this.storeservice.breadCrumb=this.breadCrumb
              // this.router.navigate(['advancesearch1/vehicle-smart']);
              // this.router.navigate(['advancesearch/',this.storeservice.breadCrumb.l1_actual_name,this.storeservice.breadCrumb.l2_actual_name,this.storeservice.breadCrumb?.l3_actual_name,val.vc_number]);
            }

            // this.router.navigate(['advancesearch1', 'vehicle-smart']);
            this.isBrtLinkVisible = true
            // this.selectedFilters = this.level3data.filter((item: any) => item.ppl_actual_name == this.breadCrumb?.l3_actual_name)
            // this.getFeature()
            // this.calculateEmi()
          }
          else {
            // document.getElementById('btnClose1').click();
          }
        }, error: (error: any) => {
          // this.displayModal = false;
          // document.getElementById('btnClose1').click();
        }
      })
    }
  }

  getSmartFilterData() {

    this.breadCrumb.l4_actual_name = "Filter"
    this.smartFilter = [];
    let data = {
      "ppl": this.productDetailsData.ppl,
      "lob": this.productDetailsData.lob,
      "application": '',
      "pl": this.productDetailsData.ppl == "Winger" ? this.productDetailsData.pl : '',
      "column_five": (this.productDetailsData.ppl == "MAV Tippers 28" || this.productDetailsData.ppl == "Magic" || this.productDetailsData.ppl == "MAV Tippers 35" ||
        this.productDetailsData.ppl == "ICV Buses" || this.productDetailsData.ppl == "LCV Buses" ||
        this.productDetailsData.ppl == "M&HCV Buses") ? this.productDetailsData.column_five : ''
    }
    this.sub.add(this.ApiService.getSmartFilter(data).subscribe({
      next: (res: any) => {
        // this.smartFilter = res.data
        // this.selectedFilters = this.level3data.filter((item: any) => item.ppl_actual_name == this.breadCrumb?.l3_actual_name)

        this.selectedFilters = this.level3DataForward.filter((item: any) => item.ppl_display_name === this.breadCrumb?.l3_actual_name)
        const keys = Object.keys(this.selectedFilters[0]);
        for (let j = 0; j < keys?.length; j++) {
          if (this.selectedFilters[0][keys[j]] == "YES") {
            this.smartFilter.push({ label: keys[j], data: res.data[keys[j]] })

          }
        }

        const filteredData = this.smartFilter.filter(item => item.data !== undefined && item.data !== null && item.data !== "");
        this.smartFilter = filteredData

        if (this.smartFilter) {
          this.storeservice.smartFilterData = this.smartFilter
          this.storeservice.level3DataImages = this.level3DataImages
          this.storeservice.json = this.json
          this.storeservice.productDetailsData = this.productDetailsData
          this.storeservice.breadCrumb = this.breadCrumb
          // this.router.navigate(['advancesearch1/smart-filter'])
          this.router.navigate(['advancesearch/', this.SearchValue, this.storeservice.breadCrumb.l1_actual_name, this.storeservice.breadCrumb.l2_actual_name, this.level2name, this.storeservice.breadCrumb?.l3_actual_name, this.vc_number, 'smart-filter']);
        }
        // this.router.navigate(['advancesearch1', 'smart-filter']);

        for (let key in this.json) {
          this.json[key] = null;
        }

      }
    }))
  }


  bookNow() {
    if (isPlatformBrowser(this.platformId)) {
      let sublob = this.productDetailsData.sub_lob.replace(/\s/g, "-")?.toLowerCase() == 'icv-trucks' ? 'trucks' : (this.productDetailsData.sub_lob.replace(/\s/g, "-")?.toLowerCase()) == 'buses' ? 'buses-vans' : this.productDetailsData.sub_lob.replace(/\s/g, "-")?.toLowerCase();
      let model = this.productDetailsData.model.replace(/\s/g, '-').replace(/\//g, '-').replace(/\+/g, '-').replace(/\./g, '-')?.toLowerCase();
      this.behaviourservice.isSmart.next(true);
      this.router.navigate(['/lead-booking/' + sublob + '/' + this.productDetailsData.lob_seo + '/' + this.productDetailsData.ppl_seo + '/' + model + '/' + this.productDetailsData.id]);
      // let element = document.getElementById('btnClose');
      // element.click();
      if (this.btnClose) {
        this.btnClose.nativeElement.click();
      } else {
        console.warn("btnClose element not found");
      }
    }
  }
  getFeature() {
    this.featureList = []
    let data = {
      "ppl": this.productDetailsData?.ppl,
      "vc_number": this.productDetailsData?.vehicle_number,
      "category": ""
    }
    this.ApiService.getFeatureList(data).subscribe({
      next: (res: any) => {
        this.featureList = res.data
        this.featureList.length = 4
      }
    })
  }
  calculateEmi() {
    let loanAmount = this.productPrice > 0 ? this.productPrice : Number(this.productPrice) && this.productPrice >= this.loanAmountOptions.floor && this.productPrice <= this.loanAmountOptions.ceil ? Number(this.productPrice) : this.loanAmountOptions.floor;
    let downPayAmount = this.downPaymentPrice > 0 ? this.downPaymentPrice :
      Number(this.downPaymentPrice) && this.downPaymentPrice >= this.loanAmountOptions.floor &&
        this.downPaymentPrice <= this.loanAmountOptions.ceil ? Number(this.downPaymentPrice) : this.downPaymentPrice;
    let numberOfMonths = (Number(this.temi.value) * 12);
    let rateOfInterest = Number(this.remi.value);
    this.userInterest = this.remi.value;
    let monthlyInterestRatio = (rateOfInterest / 100) / 12;
    this.productPrice = loanAmount;
    this.downPaymentPrice = downPayAmount
    this.userYear = this.getYears(this.temi.value);
    this.userMonths = this.getMonths(this.temi.value);
    let top = Math.pow((1 + monthlyInterestRatio), numberOfMonths);
    let bottom = top - 1;
    let sp = top / bottom;
    let mainLoanAmount = loanAmount - downPayAmount
    let emi = ((mainLoanAmount * monthlyInterestRatio) * sp);
    let full = numberOfMonths * emi;
    let interest = full - mainLoanAmount;
    this.result.emi = this.convertToIndianFormat(emi.toFixed(0));
    this.result.total = this.convertToIndianFormat(full.toFixed(0));
    this.result.interest = this.convertToIndianFormat(interest.toFixed(0));
  }
  getYears(n: any) {
    let newNum = (n + "").split(".")
    return newNum[0] ? Number(newNum[0]) : 0
  }
  getMonths(n: any) {
    let newNum = (n + "").split(".")
    return newNum[1] ? Number(newNum[1]) : 0
  }
  convertToIndianFormat(amount: any) {
    let x = amount.toString();
    var lastThree = x.substring(x?.length - 3);
    var otherNumbers = x.substring(0, x?.length - 3);
    if (otherNumbers != '')
      lastThree = ',' + lastThree;
    var res = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
    return res;
  }
  onTenureSelected(selectedTenure: any, lable: any) {
    this.selectedTenure = selectedTenure;
    this.range_obj[lable] = selectedTenure
  }
  onTenureDropDownClickHandler() {
    this.isTenureDropDownClicked = !this.isTenureDropDownClicked
  }

  brtcalculatorAPI() {
    this.Postdata_ = {};
    this.Postdata_['output_type'] = "all",
      this.Postdata_['table_name'] = "",
      this.Postdata_['vc_no'] = this.productDetailsData?.vehicle_number
    this._dataLobService.getLobFilterData("get_brt_details", this.Postdata_).subscribe((result) => {
      if (result['RESPONSE']['STATUS_CODE'] == 200) {
        if (result.RESPONSE.DATA?.length > 0) {
          this.isBrtLinkVisible = true;
          this.showBlock = true;
          this.ErrorMsg = false
          this.brt_data = result.RESPONSE.DATA[0]
          this.dataforcalculator()
        } else {
          this.isBrtLinkVisible = false;
        }
      } else {
        this.isBrtLinkVisible = false;
      }
    })
  }
  dataforcalculator() {
    this.showBlock = true;
    let brtForm;
    let lob = this.brt_data.lob

    if (lob.trim() === "HCV Cargo") {
      brtForm = 'HCV Cargo'
    } else if (lob.trim() === "HCV Const") {
      brtForm = 'HCV Const'
    } else if (lob.trim() === "ICV Trucks" || lob.trim() === "MCV Trucks" || lob.trim() === "LCV" || lob.trim() === "MCV tipper 19") {
      brtForm = 'ILMCV'
    } else if (lob.trim() === "SCV Cargo" && this.brt_data.pl === 'Ace EV') {
      brtForm = 'SCV Cargo Ace EV'
    } else if (lob.trim() === "SCV Cargo" && this.brt_data.pl !== 'Ace EV') {
      brtForm = 'SCV'
    } else if (lob.trim() === "Pickups") {
      brtForm = 'SCV'
    } else if (lob.trim() === "Buses") {
      brtForm = 'CVP'
    } else if (lob.trim() === "Winger" || lob.trim() === "SCVPass") {
      brtForm = 'CVP_MAGIC_WINGER'
    }


    let data = { form: brtForm, BRT_DATA: this.brt_data, exShowRoomPrice: this.productDetailsData?.price_range }
    this.brtFormFields = data

    this.chassisPrice = this.brtFormFields['exShowRoomPrice']
    let formName = this.brtFormFields['form']; // CVP
    // let formName = this.brtFormFields['form']; // BRT DETAILS
    this.BRT_FORM_FIELDS = this.BRT_FORM[formName];
    this.selectedAnnualKms = this.annualKmsArr[0].title.split('');
    let index = this.BRT_FORM_FIELDS.findIndex((x: { type: string; }) => x.type === 'meter');
    var arr = this.selectedAnnualKms;
    var str2 = String(arr);
    var str3 = str2.replace(/\,/g, '')
    this.BRT_FORM_FIELDS[index].value = str3
    this.annualKmItemLength = this.annualKmsArr?.length

    for (let index = 0; index < this.BRT_FORM_FIELDS?.length; index++) {
      if (this.BRT_FORM_FIELDS[index].type === 'range') {
        this.range_obj[this.BRT_FORM_FIELDS[index].label] = this.BRT_FORM_FIELDS[index].rangeArray[0]
      }
      else if (this.BRT_FORM_FIELDS[index].type === 'meter') {
        this.range_obj[this.BRT_FORM_FIELDS[index].label] = 1000
      }
    }
  }
  openBrtCalculator() {
    this.brtcalculatorAPI()
    this.isBrtLinkVisible = true

  }
  getChildValue(event) {
    if (isPlatformBrowser(this.platformId)) {
      if (event == "search1") {
        localStorage.removeItem('l1SearchData')
        localStorage.removeItem('l2SearchData')
        localStorage.removeItem('l3SearchData')
        this.storeservice.breadCrumb.l4_actual_name = ''
        this.storeservice.breadCrumb.l1_actual_name = '';
        this.storeservice.breadCrumb.l2_actual_name = '';
        this.storeservice.breadCrumb.l3_actual_name = '';
        // this.selectedLevel2ID = '';
        // this.selectedLevel3ID = '';
      }
      else if (event == "search2") {
        this.storeservice.isclick.next(false)
        localStorage.removeItem('l2SearchData');
        localStorage.removeItem('l3SearchData');
        // this.selectedLevel2ID = '';
        // this.selectedLevel3ID = '';
        this.storeservice.breadCrumb.l2_actual_name = this.breadCrumb.l2_actual_name = '';
        this.storeservice.breadCrumb.l3_actual_name = this.breadCrumb.l3_actual_name = ''
        this.storeservice.breadCrumb.l4_actual_name = this.breadCrumb.l4_actual_name = ''
        this.behaviourservice.SearchConsoleFilterCount.next(0);
      }
      else if (event == "search3") {
        this.storeservice.isclick.next(true)
        this.CabinTypeFIlter = false;
        this.FuelTypeFilter = false;
        this.BodyTypeFilter = false
        this.DeckLengthFilter = false
        // this.FilterCLicked = false;
        this.FifthFilter = false;
        this.SixthFilter = false;
        this.storeservice.breadCrumb.l3_actual_name = '';
        this.storeservice.breadCrumb.l4_actual_name = ''

        this.behaviourservice.SearchConsoleFilterCount.next(0);
        this.smartFilter = [];
        localStorage.removeItem('l3SearchData');
        this.brtEstimateTotalEarning_1year = ''


        // this.isDetailsVisible = ''

        // this.selectedLevel2ID = '';

        // this.selectedLevel3ID = '';

        // this.breadCrumb.l2_actual_name = '';


      }
    }
  }
  closeall() {
    if (isPlatformBrowser(this.platformId)) {
      let elements = document.getElementById('searchConsoleDefult123');
      elements.click();
    }
  }
  userData: any = {};
  PMT(rate: any, nperiod: any, pv: any, fv: any, type: any) {
    if (!fv) fv = 0;
    if (!type) type = 0;

    if (rate == 0) return -(pv + fv) / nperiod;

    var pvif = Math.pow(1 + rate, nperiod);
    var pmt = rate / (pvif - 1) * -(pv * pvif + fv);

    if (type == 1) {
      pmt /= (1 + rate);
    };
    return pmt;
  }
  getData(data: NgForm) {
    let merged = { ...data, ...this.range_obj };

    var arr = this.selectedAnnualKms;
    var str2 = String(arr);
    var str3 = str2.replace(/\,/g, '')
    merged['Kms per trip'] = str3

    let isBrtFormValid = Object.values(merged).every((value: any) => {
      this.ErrorMsg = true
      if (value === undefined || value.toString().trim() === '' || (value === null)) {
        return false;
      }
      return true;
    });

    //Check the form input field validation
    const keys = Object.keys(merged) as Array<keyof typeof merged>;

    keys.forEach((key: any) => {
      for (let i = 0; i < this.BRT_FORM_FIELDS?.length; i++) {
        if (!merged[key]) {
          if (this.BRT_FORM_FIELDS[i].label === key) {
            this.BRT_FORM_FIELDS[i].isValid = false;
            break;
          }
        }
        else {
          if (this.BRT_FORM_FIELDS[i].label === key) {
            this.BRT_FORM_FIELDS[i].isValid = true;
            break;
          }
        }
      }
    })

    if (!merged['Loan Tenure in months']) {
      for (let i = 0; i < this.BRT_FORM_FIELDS?.length; i++) {
        if (this.BRT_FORM_FIELDS[i].label === 'Loan Tenure in months') {
          this.BRT_FORM_FIELDS[i].isValid = false;
          break;
        }
      }
      isBrtFormValid = false;
    }



    if (isBrtFormValid === true) {
      let calculated_field_obj: any = {}

      let b1 = this.chassisPrice;
      if (this.brtFormFields['form'] === "HCV Cargo" || this.brtFormFields['form'] === "SCV Cargo Ace EV" || this.brtFormFields['form'] === "SCV") {

        calculated_field_obj['No. of trips per year'] = Number(merged['No. of trips per month']) * 12

        calculated_field_obj['Total Kms per year'] = calculated_field_obj['No. of trips per year'] * Number(merged['Kms per trip'])

        calculated_field_obj['Freight earned per year (Rs/yr)'] = Number(merged['Freight Rate']) * Number(merged['Actual Load Carrying']) * calculated_field_obj['Total Kms per year']


        // let b1 = Number(this.brtFormFields['BRT_DATA']['details']['chassis_price']) //Currently vehicl price is coming from brt file


        let b3 = Number(merged['LTV (Loan to Value) Chassis']) / 100
        let b4 = Number(merged['LTV (Loan to Value) Body']) / 100

        calculated_field_obj['LTV (Incl. Chassis and Body)'] = (b1 * b3) + (Number(merged['Body Price']) * b4)

        let rate = (Number(merged['Finance Charge(IRR)']) / 100) / 12
        let no_of_payment_periods = Number(merged['Loan Tenure in months'])
        let present_value = calculated_field_obj['LTV (Incl. Chassis and Body)']
        let pmt = this.PMT(rate, no_of_payment_periods, present_value, 0, 0)
        calculated_field_obj['EMI'] = Math.abs(pmt)

        calculated_field_obj['Annualised EMI'] = calculated_field_obj['EMI'] * 12

        calculated_field_obj['Total Fuel consumed per year (L)'] = calculated_field_obj['Total Kms per year'] / Number(this.brtFormFields['BRT_DATA']['details']['avg_fuel_economy'])


        calculated_field_obj['Total DEF consumed per year (L)'] = calculated_field_obj['Total Fuel consumed per year (L)'] * (Number(this.brtFormFields['BRT_DATA']['details']['def_consumption_percentage']) / 100)

        let c1 = Number(this.brtFormFields['BRT_DATA']['details']['avg_fuel_economy']);

        let c2 = Number(merged['Avg. Fuel Price Per L']);

        if (this.brtFormFields['form'] === "SCV Cargo Ace EV") {
          c2 = Number(merged['Avg. Electricity cost per KWh']);

          //Annual Tyre Cost for SCV ACE EV - comment by Kartik.
          //Avg front tyre cost column is used in database to store tyre cost per km value i.e 0.25 for SCV ACE EV
          // whenever table will be altered this tyre cost per km column should be added for SCV BRT 46

          calculated_field_obj['Annual Tyre Cost'] = calculated_field_obj['Total Kms per year'] * Number(this.brtFormFields['BRT_DATA']['details']['avg_front_tyre_cost'])
        }

        let c3 = calculated_field_obj['Total Fuel consumed per year (L)']

        let c4 = Number(this.brtFormFields['BRT_DATA']['details']['avg_def_price']);

        let c6 = calculated_field_obj['Total DEF consumed per year (L)']

        // let c1 = (Number(merged['Avg. Fuel Price Per L'])*calculated_field_obj['Total Fuel consumed per year (L)']);

        // let c2 = (Number(this.brtFormFields['BRT_DATA']['details']['avg_def_price'])*calculated_field_obj['Total DEF consumed per year (L)'])

        calculated_field_obj['Annual Fluid Cost'] = (c2 * c3) + (c4 * c6)


        let e5 = 0;
        if (this.brtFormFields['form'] !== "SCV" && this.brtFormFields['form'] !== "ILMCV" && this.brtFormFields['form'] !== "SCV Cargo Ace EV") {
          let e1 = Number(this.brtFormFields['BRT_DATA']['details']['avg_front_tyre_cost']) * Number(this.brtFormFields['BRT_DATA']['details']['no_of_front_tyres'])
          let e2 = Number(this.brtFormFields['BRT_DATA']['details']['avg_rear_tyre_cost']) * Number(this.brtFormFields['BRT_DATA']['details']['no_of_rear_tyres'])
          let e3 = e1 / Number(this.brtFormFields['BRT_DATA']['details']['front_tyre_life_km'])
          let e4 = e2 / Number(this.brtFormFields['BRT_DATA']['details']['rear_tyre_life_kms'])
          e5 = e3 + e4
          calculated_field_obj['Annual Tyre Cost'] = e5 * Number(calculated_field_obj['Total Kms per year'])
        }

        if (this.brtFormFields['form'] === "SCV") {
          calculated_field_obj['Annual Tyre Cost'] = e5;
        }


        if (Number.isNaN(calculated_field_obj['Annual Tyre Cost'])) {
          calculated_field_obj['Annual Tyre Cost'] = 0
        }

        //maintence cost (mc) is combined with (Annual Scheduled Service Cost + Annual Unscheduled Service Cost)
        let mc = Number(this.brtFormFields['BRT_DATA']['details']['maintenance_cost']);

        let c17 = Number(calculated_field_obj['Total Kms per year']) * Number(merged['Actual Load Carrying']);
        let c18;

        if (this.brtFormFields['form'] === "HCV Cargo") {
          c18 = mc * c17;
        } else {
          c18 = mc;
        }

        calculated_field_obj['Annual Service & Maintenance Cost'] = c18;

        calculated_field_obj['Toll Cost per year'] = Number(this.brtFormFields['BRT_DATA']['details']['toll_charges_per_km']) * Number(calculated_field_obj['Total Kms per year'])

        if (this.brtFormFields['form'] === "HCV Cargo") {
          calculated_field_obj['Toll Cost per year'] = Number(this.brtFormFields['BRT_DATA']['details']['toll_charges_per_km']) * c17
        }

        calculated_field_obj['Annual Additional Cost (Insurance, Taxes, Drivery Salary, Management etc.)'] = (4 / 100) * b1

        calculated_field_obj['TOTAL ANNUAL EXPENDITURE'] = calculated_field_obj['Annual Additional Cost (Insurance, Taxes, Drivery Salary, Management etc.)'] + calculated_field_obj['Toll Cost per year'] + calculated_field_obj['Annual Service & Maintenance Cost'] + calculated_field_obj['Annual Tyre Cost'] + calculated_field_obj['Annual Fluid Cost'] + calculated_field_obj['Annualised EMI']

        if (Number.isNaN(calculated_field_obj['TOTAL ANNUAL EXPENDITURE'])) {
          calculated_field_obj['TOTAL ANNUAL EXPENDITURE'] = 0
        }
        calculated_field_obj['Estimated Profit in 1 year'] = calculated_field_obj['Freight earned per year (Rs/yr)'] - calculated_field_obj['TOTAL ANNUAL EXPENDITURE']

        let rs1 = b1 + Number(merged['Body Price']);
        let rs2 = 1 + Number(merged['Annual depreciation rate']) / 100;
        let rs3 = Math.pow(rs2, 4);

        calculated_field_obj['Resale value after 4 years'] = (rs1 / rs3).toFixed(2);

        calculated_field_obj['Resale value after 4 years'] = Number(calculated_field_obj['Resale value after 4 years'])
        calculated_field_obj['Total Earnings in 4 year'] = ((calculated_field_obj['Estimated Profit in 1 year'] * 4) + calculated_field_obj['Resale value after 4 years']);
        calculated_field_obj['Total Earnings in 4 year'] = Number(calculated_field_obj['Total Earnings in 4 year'])

      }

      else if (this.brtFormFields['form'] === "ILMCV") {
        let a1 = Number(merged['Freight Rate'])

        let a2 = Number(merged['Actual Load Carrying'])

        let a4 = Number(merged['No. of trips per month']) * 12

        calculated_field_obj['No. of trips per year'] = a4;

        let a5 = Number(merged['Kms per trip'])

        let a6 = a4 * a5;

        calculated_field_obj['Total Kms per year'] = a6;

        let a7 = a1 * a2 * a6

        calculated_field_obj['Freight earned per year (Rs/yr)'] = a7;

        // let b1 = Number(this.brtFormFields['BRT_DATA']['details']['chassis_price']) //Currently vehicl price is coming from brt file


        let b2 = Number(merged['Body Price'])

        let b3 = Number(merged['LTV (Loan to Value) Chassis']) / 100

        let b4 = Number(merged['LTV (Loan to Value) Body']) / 100

        let b5 = Number(merged['Finance Charge(IRR)']);

        let b6 = (b1 * b3) + (b2 * b4)

        calculated_field_obj['LTV (Incl. Chassis and Body)'] = b6

        let b7 = Number(merged['Loan Tenure in months'])

        let rate = (Number(merged['Finance Charge(IRR)']) / 100) / 12
        let no_of_payment_periods = b7
        let present_value = calculated_field_obj['LTV (Incl. Chassis and Body)']
        let pmt = this.PMT(rate, no_of_payment_periods, present_value, 0, 0)

        let b8 = Math.abs(pmt)

        calculated_field_obj['EMI'] = b8

        calculated_field_obj['Annualised EMI'] = b8 * 12

        let c1 = Number(this.brtFormFields['BRT_DATA']['details']['avg_fuel_economy'])

        let c2 = Number(merged['Avg. Fuel Price Per L']);

        let c3 = a6 / c1
        calculated_field_obj['Total Fuel consumed per year (L)'] = c3

        let c4 = Number(this.brtFormFields['BRT_DATA']['details']['avg_def_price']);

        let c5 = Number(this.brtFormFields['BRT_DATA']['details']['def_consumption_percentage']) / 100

        let c6 = c3 * c5;

        calculated_field_obj['Total DEF consumed per year (L)'] = c6

        let c7 = (c2 * c3) + (c4 * c6)

        calculated_field_obj['Annual Fluid Cost'] = c7;

        calculated_field_obj['Total Fuel consumed per year (L)'] = c3

        calculated_field_obj['Total DEF consumed per year (L)'] = c6

        let c8 = Number(this.brtFormFields['BRT_DATA']['details']['front_tyre_life_km']);
        let c9 = Number(this.brtFormFields['BRT_DATA']['details']['rear_tyre_life_kms']);
        let c10 = Number(this.brtFormFields['BRT_DATA']['details']['avg_front_tyre_cost']);
        let c11 = Number(this.brtFormFields['BRT_DATA']['details']['avg_rear_tyre_cost']);

        let c14 = (((c10 / c8) + (c11 / c9))) * a6

        calculated_field_obj['Annual Tyre Cost'] = c14;

        if (Number.isNaN(calculated_field_obj['Annual Tyre Cost'])) {
          calculated_field_obj['Annual Tyre Cost'] = 0
        }

        //maintence cost (mc) is combined with (Annual Scheduled Service Cost + Annual Unscheduled Service Cost)
        let mc = Number(this.brtFormFields['BRT_DATA']['details']['maintenance_cost']);

        let c17 = Number(calculated_field_obj['Total Kms per year']) * mc;



        if (this.brtFormFields['form'] === "ILMCV") {
          calculated_field_obj['Annual Service & Maintenance Cost'] = c17;
        }

        // calculated_field_obj['Annual Service & Maintenance Cost'] = mc * c17;

        calculated_field_obj['Toll Cost per year'] = Number(this.brtFormFields['BRT_DATA']['details']['toll_charges_per_km']) * Number(calculated_field_obj['Total Kms per year'])

        calculated_field_obj['Annual Additional Cost (Insurance, Taxes, Drivery Salary, Management etc.)'] = (4 / 100) * b1

        calculated_field_obj['TOTAL ANNUAL EXPENDITURE'] = calculated_field_obj['Annual Additional Cost (Insurance, Taxes, Drivery Salary, Management etc.)'] + calculated_field_obj['Toll Cost per year'] + calculated_field_obj['Annual Service & Maintenance Cost'] + calculated_field_obj['Annual Tyre Cost'] + calculated_field_obj['Annual Fluid Cost'] + calculated_field_obj['Annualised EMI']

        if (Number.isNaN(calculated_field_obj['TOTAL ANNUAL EXPENDITURE'])) {
          calculated_field_obj['TOTAL ANNUAL EXPENDITURE'] = 0
        }
        calculated_field_obj['Estimated Profit in 1 year'] = calculated_field_obj['Freight earned per year (Rs/yr)'] - calculated_field_obj['TOTAL ANNUAL EXPENDITURE']

        let rs1 = b1 + Number(merged['Body Price']);
        let rs2 = 1 + Number(merged['Annual depreciation rate']) / 100
        let rs3 = Math.pow(rs2, 4);

        calculated_field_obj['Resale value after 4 years'] = (rs1 / rs3).toFixed(2);

        calculated_field_obj['Resale value after 4 years'] = Number(calculated_field_obj['Resale value after 4 years'])
        calculated_field_obj['Total Earnings in 4 year'] = ((calculated_field_obj['Estimated Profit in 1 year'] * 4) + calculated_field_obj['Resale value after 4 years']);
        calculated_field_obj['Total Earnings in 4 year'] = Number(calculated_field_obj['Total Earnings in 4 year'])
      }

      else if (this.brtFormFields['form'] === "HCV Const") {
        let a1 = Number(merged['Freight Rate'])

        let a2 = Number(merged['Actual Load Carrying'])

        let a3 = Number(merged['No. of trips per month'])

        let a8 = Number(merged['Average Lead distance'])

        let a4 = a3 * 12

        calculated_field_obj['No. of trips per year'] = a4;

        let a5 = Number(merged['Hrs per trip'])

        let a6 = a4 * a5;

        calculated_field_obj['Total Hrs per year'] = a6;

        let a7 = a1 * a2 * a6

        calculated_field_obj['Freight earned per year (Rs/yr)'] = a7;

        // let b1 = Number(this.brtFormFields['BRT_DATA']['details']['chassis_price']) //Currently vehicl price is coming from brt file


        let b2 = Number(merged['Body Price'])

        let b3 = Number(merged['LTV (Loan to Value) Chassis']) / 100

        let b4 = Number(merged['LTV (Loan to Value) Body']) / 100

        let b5 = Number(merged['Finance Charge(IRR)']);

        let b6 = (b1 * b3) + (b2 * b4)

        calculated_field_obj['LTV (Incl. Chassis and Body)'] = b6

        let b7 = Number(merged['Loan Tenure in months'])

        let rate = (Number(merged['Finance Charge(IRR)']) / 100) / 12
        let no_of_payment_periods = b7
        let present_value = calculated_field_obj['LTV (Incl. Chassis and Body)']
        let pmt = this.PMT(rate, no_of_payment_periods, present_value, 0, 0)

        let b8 = Math.abs(pmt)

        calculated_field_obj['EMI'] = b8

        calculated_field_obj['Annualised EMI'] = b8 * 12

        let c1 = Number(this.brtFormFields['BRT_DATA']['details']['avg_fuel_economy'])
        let c8 = (a8 * 2) / c1

        calculated_field_obj['Avergae fuel consumed per trip'] = c8;

        let c9 = c8 / a5;

        calculated_field_obj['Average fuel economy per trip (LPH)'] = c9

        let c2 = Number(merged['Avg. Fuel Price Per L']);

        let c3 = a6 * c9
        calculated_field_obj['Total Fuel consumed per year (L)'] = c3

        let c4 = Number(this.brtFormFields['BRT_DATA']['details']['avg_def_price']);

        let c5 = Number(this.brtFormFields['BRT_DATA']['details']['def_consumption_percentage']) / 100

        let c6 = c3 * c5;

        calculated_field_obj['Total DEF consumed per year (L)'] = c6

        let c7 = (c2 * c3) + (c4 * c6)

        calculated_field_obj['Annual Fluid Cost'] = c7;

        calculated_field_obj['Total Fuel consumed per year (L)'] = c3

        calculated_field_obj['Total DEF consumed per year (L)'] = c6

        let c21 = Number(this.brtFormFields['BRT_DATA']['details']['front_tyre_life_km']);
        let c22 = Number(this.brtFormFields['BRT_DATA']['details']['rear_tyre_life_kms']);
        let c10 = Number(this.brtFormFields['BRT_DATA']['details']['avg_front_tyre_cost']);
        let c11 = Number(this.brtFormFields['BRT_DATA']['details']['avg_rear_tyre_cost']);
        let c12 = Number(this.brtFormFields['BRT_DATA']['details']['no_of_front_tyres']);
        let c13 = Number(this.brtFormFields['BRT_DATA']['details']['no_of_rear_tyres']);

        let c14 = (((c10 * c12) / c21) + ((c11 * c13) / c22)) * a6

        calculated_field_obj['Annual Tyre Cost'] = c14;

        if (Number.isNaN(calculated_field_obj['Annual Tyre Cost'])) {
          calculated_field_obj['Annual Tyre Cost'] = 0
        }

        //maintence cost (mc) is combined with (Annual Scheduled Service Cost + Annual Unscheduled Service Cost)
        let mc = Number(this.brtFormFields['BRT_DATA']['details']['maintenance_cost']);

        let c17 = a6 * Number(merged['Actual Load Carrying']);
        let c18 = Number(this.brtFormFields['BRT_DATA']['details']['toll_charges_per_km'])

        calculated_field_obj['Annual Service & Maintenance Cost'] = mc * c17;

        calculated_field_obj['Toll Cost per year'] = c18 * c17

        calculated_field_obj['Annual Additional Cost (Insurance, Taxes, Drivery Salary, Management etc.)'] = (4 / 100) * b1

        let d = calculated_field_obj['Annual Additional Cost (Insurance, Taxes, Drivery Salary, Management etc.)'] + calculated_field_obj['Toll Cost per year'] + calculated_field_obj['Annual Service & Maintenance Cost'] + calculated_field_obj['Annual Tyre Cost'] + calculated_field_obj['Annual Fluid Cost'] + calculated_field_obj['Annualised EMI']
        calculated_field_obj['TOTAL ANNUAL EXPENDITURE'] = d

        if (Number.isNaN(calculated_field_obj['TOTAL ANNUAL EXPENDITURE'])) {
          calculated_field_obj['TOTAL ANNUAL EXPENDITURE'] = 0
        }

        let e = a7 - d
        calculated_field_obj['Estimated Profit in 1 year'] = e;

        let rs1 = b1 + Number(merged['Body Price']);
        let rs2 = 1 + Number(merged['Annual depreciation rate']) / 100
        let rs3 = Math.pow(rs2, 4);

        calculated_field_obj['Resale value after 4 years'] = (rs1 / rs3).toFixed(2);

        calculated_field_obj['Resale value after 4 years'] = Number(calculated_field_obj['Resale value after 4 years'])
        calculated_field_obj['Total Earnings in 4 year'] = ((calculated_field_obj['Estimated Profit in 1 year'] * 4) + calculated_field_obj['Resale value after 4 years']);
        calculated_field_obj['Total Earnings in 4 year'] = Number(calculated_field_obj['Total Earnings in 4 year'])
      }

      else if (this.brtFormFields['form'] === "CVP" || this.brtFormFields['form'] === "CVP_MAGIC_WINGER") {

        let a4 = Number(merged['No. of trips per month']) * 12;

        let a6 = a4 * Number(merged['Kms per trip']);

        // n => Earning per seat per trip for CVP
        let n = Number(merged['Earning per seat per trip'])

        // n => Earning per seat per trip for CVP_MAGIC_WINGER for calculation
        if (this.brtFormFields['form'] === "CVP_MAGIC_WINGER") {
          let k = merged['Earning per seat per Km']
          n = Number(k) * Number(merged['Kms per trip'])
        }

        let a7 = Number(n) * Number(merged['Number of passengers per trip']) * a4;

        let a8 = a7 / a6;
        // let b1 = Number(this.brtFormFields['BRT_DATA']['details']['chassis_price']) //Currently vehicl price is coming from brt file

        let b2 = Number(merged['Body Price'])
        let b3 = Number(merged['LTV (Loan to Value) Chassis']) / 100
        let b4 = Number(merged['LTV (Loan to Value) Body']) / 100
        let b5 = Number(merged['Finance Charge(IRR)']) / 100;
        let b6 = (b1 * b3) + (b2 * b4);
        let b7 = Number(merged['Loan Tenure in months'])
        let rate = b5 / 12
        let no_of_payment_periods = b7
        let present_value = b6
        let pmt = this.PMT(rate, no_of_payment_periods, present_value, 0, 0)
        let b8 = Math.abs(pmt)
        let b9 = Number(b8 * 12)
        let c1 = Number(this.brtFormFields['BRT_DATA']['details']['avg_fuel_economy'])

        let c2 = Number(merged['Avg. Fuel Price Per L'])

        let c3 = a6 / c1

        let c4 = Number(this.brtFormFields['BRT_DATA']['details']['avg_def_price'])
        let c5 = Number(this.brtFormFields['BRT_DATA']['details']['def_consumption_percentage']) / 100

        let c6 = c3 * c5;

        let c7 = (c2 * c3) + (c4 * c6)

        let c8 = Number(this.brtFormFields['BRT_DATA']['details']['front_tyre_life_km'])
        let c9 = Number(this.brtFormFields['BRT_DATA']['details']['rear_tyre_life_kms'])
        let c10 = Number(this.brtFormFields['BRT_DATA']['details']['avg_front_tyre_cost'])
        let c11 = Number(this.brtFormFields['BRT_DATA']['details']['avg_rear_tyre_cost'])
        let c12 = Number(this.brtFormFields['BRT_DATA']['details']['no_of_front_tyres'])
        let c13 = Number(this.brtFormFields['BRT_DATA']['details']['no_of_rear_tyres'])

        let c14 = (((c10 * c12) / c8) + ((c11 * c13) / c9)) * a6; //correct


        if (Number.isNaN(c14)) {
          c14 = 0
        }

        let mc = Number(this.brtFormFields['BRT_DATA']['details']['maintenance_cost'])

        let c17 = mc * a6


        let c18 = Number(this.brtFormFields['BRT_DATA']['details']['toll_charges_per_km'])

        let c19 = c18 * a6;

        let c20 = 0.04 * b1;


        let d = c20 + c19 + c17 + c14 + c7 + b9;


        let e = d / a6;

        let f = a7 - d

        let g = a8 - e;

        let h = Number(merged['Annual depreciation rate'])

        let i = (b1 + b2) / (Math.pow((1 + (h / 100)), 4));


        let j = (f * 4) + i;

        calculated_field_obj['Revenue per year (Rs/yr)'] = a7;
        calculated_field_obj['Earning per KM (EPK)'] = a8;
        calculated_field_obj['Annualised EMI'] = b9;
        calculated_field_obj['Annual Fluid Cost'] = c7;
        calculated_field_obj['Annual Tyre Cost'] = c14;
        calculated_field_obj['Annual Service & Maintenance Cost'] = c17;
        calculated_field_obj['Toll Cost per year'] = c19;
        calculated_field_obj['Annual Additional Cost (Insurance, Taxes, Drivery Salary, Management etc.)'] = c20;
        calculated_field_obj['TOTAL ANNUAL EXPENDITURE'] = d;
        calculated_field_obj['Cost Per KM (CPK)'] = e;
        calculated_field_obj['Estimated Profit in 1 year'] = f;
        calculated_field_obj['Profit per Km (PPK = EPK - CPK)'] = g;
        calculated_field_obj['Resale value after 4 years'] = i;
        calculated_field_obj['Total Earnings in 4 year'] = j;

      }


      for (let x in calculated_field_obj) {
        calculated_field_obj[x] = Math.trunc(calculated_field_obj[x])
      }
      calculated_field_obj['form'] = this.brtFormFields['form']
      this._dataLobService.updateDatetimeValue(calculated_field_obj);
      this.modalservice.dismissAll()
      // }

    } else {
      this.ErrorMsg = true;
    }


  }
  dataofcalculatedamount() {
    if (isPlatformBrowser(this.platformId)) {
      this.sharePostdatetime = this._dataLobService.sharePostdatetime_.subscribe((data: any) => {
        this.isBrtDetailsVisible = true;
        this.isBrtPriceBreakUpVisibleToSummary.emit(true);
        this.brtEstimateTotalEarningSign = 'Positive'
        this.brtEstimateTotalEarning = data['Total Earnings in 4 year'];
        this.brtEstimateTotalEarning_1year = data['Estimated Profit in 1 year'];
        this.brtViewDetailsData = this.getBrtViewDetails(data);
        this.brtForm = data['form']

        this.ErrorMsg = false;

        let elements = document.getElementById('searchConsoleDefult123');
        elements.click()
        if (this.brtEstimateTotalEarning_1year != '') {
          document.getElementById("btnclosebrt").click()
          this.ErrorMsg = false;
          this.rangeInput.nativeElement.value = 0;
        }
      });

    }
  }
  getBrtViewDetails(brtData: any) {
    let brtViewDetailsArr = []
    const brtViewDetailsObjectKeys = Object.keys(brtData)

    for (let i = 0; i < brtViewDetailsObjectKeys?.length; i++) {
      let tempObj: any = {}
      if (brtViewDetailsObjectKeys[i] === 'Freight earned per year (Rs/yr)') {
        tempObj['title'] = 'Freight earned per year';
        tempObj['price'] = brtData['Freight earned per year (Rs/yr)'];
        tempObj['unit'] = '/yr'
        tempObj['type'] = 'title'
      } else if (brtViewDetailsObjectKeys[i] === 'Annualised EMI') {
        tempObj['title'] = 'Annualised EMI';
        tempObj['price'] = brtData['Annualised EMI'];
        tempObj['unit'] = '/yr'
        tempObj['type'] = 'title'
      } else if (brtViewDetailsObjectKeys[i] === 'Annual Fluid Cost') {
        tempObj['title'] = 'Annual Fluid Cost';
        tempObj['price'] = brtData['Annual Fluid Cost'];
        tempObj['unit'] = '/yr'
        tempObj['type'] = 'title'
      }
      else if (brtViewDetailsObjectKeys[i] === 'Annual Tyre Cost') {
        tempObj['title'] = 'Annual Tyre Cost';
        tempObj['price'] = brtData['Annual Tyre Cost'];
        tempObj['unit'] = '/yr'
        tempObj['type'] = 'title'
      }
      else if (brtViewDetailsObjectKeys[i] === 'Annual Service & Maintenance Cost') {
        tempObj['title'] = 'Annual Service & Maintenance Cost';
        tempObj['price'] = brtData['Annual Service & Maintenance Cost'];
        tempObj['unit'] = '/yr'
        tempObj['type'] = 'title'
      }
      else if (brtViewDetailsObjectKeys[i] === 'Toll Cost per year') {
        tempObj['title'] = 'Toll Cost per year';
        tempObj['price'] = brtData['Toll Cost per year'];
        tempObj['unit'] = '/yr'
        tempObj['type'] = 'title'
      }
      else if (brtViewDetailsObjectKeys[i] === 'Annual Additional Cost (Insurance, Taxes, Drivery Salary, Management etc.)') {
        tempObj['title'] = 'Annual Additional Cost';
        tempObj['subTitle'] = '(Insurance, Taxes, Drivery Salary, Management etc.)';
        tempObj['price'] = brtData['Annual Additional Cost (Insurance, Taxes, Drivery Salary, Management etc.)'];
        tempObj['unit'] = '/yr'
        tempObj['type'] = 'titleNSubTitle'
      }
      else if (brtViewDetailsObjectKeys[i] === 'TOTAL ANNUAL EXPENDITURE') {
        tempObj['title'] = 'Total Annual Expenditure';
        tempObj['price'] = brtData['TOTAL ANNUAL EXPENDITURE'];
        tempObj['unit'] = '/yr'
        tempObj['type'] = 'bold'
      }
      else if (brtViewDetailsObjectKeys[i] === 'Estimated Profit in 1 year') {
        tempObj['title'] = 'Estimated Profit in 1 year';
        tempObj['price'] = brtData['Estimated Profit in 1 year'];
        tempObj['unit'] = '/yr'
        tempObj['type'] = 'bold'
      }
      else if (brtViewDetailsObjectKeys[i] === 'Resale value after 4 years') {
        tempObj['title'] = 'Resale value after 4 years';
        tempObj['price'] = brtData['Resale value after 4 years'];
        tempObj['unit'] = ''
        tempObj['type'] = 'bold'
      }
      else if (brtViewDetailsObjectKeys[i] === 'Total Earnings in 4 year') {
        tempObj['title'] = 'Estimated Total Earnings in 4 year';
        tempObj['price'] = brtData['Total Earnings in 4 year'];
        tempObj['unit'] = ''
        tempObj['type'] = 'bold'
      } else if (brtViewDetailsObjectKeys[i] === 'Revenue per year (Rs/yr)') {
        tempObj['title'] = 'Revenue per year';
        tempObj['price'] = brtData['Revenue per year (Rs/yr)'];
        tempObj['unit'] = '/yr'
        tempObj['type'] = 'title'
      } else if (brtViewDetailsObjectKeys[i] === 'Earning per KM (EPK)') {
        tempObj['title'] = 'Earning per KM (EPK)';
        tempObj['price'] = brtData['Earning per KM (EPK)'];
        tempObj['unit'] = '/Km'
        tempObj['type'] = 'title'
      }

      if (Object.keys(tempObj)?.length != 0)
        brtViewDetailsArr.push(tempObj)
    }
    return brtViewDetailsArr;
  }
  annualKmPrevClick(selectedAnnualKmValue: any, label: any) {
    //(this.currentSelectedAnnualKmsIndex)
    if (this.currentSelectedAnnualKmsIndex <= 0) {
      this.selectedAnnualKms =
        this.annualKmsArr[this.currentSelectedAnnualKmsIndex].title.split('');
    } else {
      this.currentSelectedAnnualKmsIndex -= 1;
    }
    this.selectedAnnualKms = this.annualKmsArr[this.currentSelectedAnnualKmsIndex].title.split('');
    var arr = this.selectedAnnualKms;
    var str2 = String(arr);
    var str3 = str2.replace(/\,/g, '')
    this.range_obj[label] = str3
    let index = this.BRT_FORM_FIELDS.findIndex((x: { label: string; }) => x.label === label);
    this.BRT_FORM_FIELDS[index].value = str3
  }

  annualKmNextClick(selectedAnnualKmValue: any, label: any) {
    //(this.currentSelectedAnnualKmsIndex)

    if (this.currentSelectedAnnualKmsIndex >= this.annualKmItemLength - 1) {
      this.selectedAnnualKms =
        this.annualKmsArr[this.currentSelectedAnnualKmsIndex].title.split('');
    } else {
      this.currentSelectedAnnualKmsIndex += 1;
    }
    this.selectedAnnualKms = this.annualKmsArr[this.currentSelectedAnnualKmsIndex].title.split('');
    var arr = this.selectedAnnualKms;
    var str2 = String(arr);
    var str3 = str2.replace(/\,/g, '')
    this.range_obj[label] = str3
    let index = this.BRT_FORM_FIELDS.findIndex((x: { label: string; }) => x.label === label);
    this.BRT_FORM_FIELDS[index].value = str3
  }
  toggleTooltip() {
    this.tooltipOpen = !this.tooltipOpen;
  }
  toggleTooltipBrtpop() {
    this.tooltipOpenBrt = !this.tooltipOpenBrt;
  }
  onFocus(property_name:any,event:any): void {
    let value = event.target.value;

    let index = this.BRT_FORM_FIELDS.findIndex((x: { label: string; }) => x.label === property_name);

    if(value == ""){
      value = 0;
      this.range_obj[this.BRT_FORM_FIELDS[index].label] = value
      return
    }

    const regex = new RegExp(/^\d*\.?\d*$/);
    const isDecimalOrNumber = regex.test(value)
    if(!isDecimalOrNumber) {
      this.BRT_FORM_FIELDS[index].value = 0
      this.range_obj[this.BRT_FORM_FIELDS[index].label] = 0
      return
    }

    value = Number(value)
    if(property_name === 'Finance Charge(IRR)'){
      if(value > 20){
        value = 20
      }
    }else if(property_name === 'Actual Load Carrying'){
      if(value > 100){
        value = 100
      }
    }else if(property_name === 'Hrs per trip'){
      if(value > 24){
        value = 24
      }
    }else{
      if(value > 100){
        value = 100
      }
    }
    this.BRT_FORM_FIELDS[index].value = value
    this.range_obj[this.BRT_FORM_FIELDS[index].label] = value
  }
  onFocusout(property_name:any,event:any): void {
    let index = this.BRT_FORM_FIELDS.findIndex((x: { label: string; }) => x.label === property_name);
    if(event.target.value === ''){
      if(property_name === 'Kms per trip'){
        this.selectedAnnualKms = this.annualKmsArr[0].title.split('');
        var arr = this.selectedAnnualKms;
        var str2 = String(arr);
        var str3 = str2.replace(/\,/g, '')
        this.BRT_FORM_FIELDS[index].value = str3
      }else{
        this.BRT_FORM_FIELDS[index].value = 0
      }
    }else{
      if(property_name === 'Finance Charge(IRR)'){
        if(event.target.value > 20){
          event.target.value = 20
          this.BRT_FORM_FIELDS[index].value = event.target.value
        }
      }else if(property_name === 'Actual Load Carrying'){
        if(event.target.value > 100){
          event.target.value = 100
          this.BRT_FORM_FIELDS[index].value = event.target.value
        }
      }else if(property_name === 'Hrs per trip'){
        if(event.target.value > 24){
          event.target.value = 24
          this.BRT_FORM_FIELDS[index].value = event.target.value
        }
      }else if(property_name === 'Kms per trip'){
        if(event.target.value > 3000){
          event.target.value = 3000
          this.BRT_FORM_FIELDS[index].value = event.target.value
        }
      }else{
        if(event.target.value > 100){
          event.target.value = 100
          this.BRT_FORM_FIELDS[index].value = event.target.value
        }
      }
    }
  }
  onFocus_meter(property_name:any,event:any): void{
    this.range_obj[property_name] = event.target.value
    this.selectedAnnualKms = event.target.value.split('');
    let index = this.BRT_FORM_FIELDS.findIndex((x: { label: string; }) => x.label === property_name);
    this.BRT_FORM_FIELDS[index].value = event.target.value

    if(event.target.value === ''){
      this.selectedAnnualKms = this.annualKmsArr[0].title.split('');
    }else{
      if(property_name === 'Kms per trip'){
        if(event.target.value > 3000){
          let val = '3000'
          this.selectedAnnualKms = val.split('');
          this.range_obj[property_name] = 3000
          this.BRT_FORM_FIELDS[index].value = 3000
        }
      }
    }
  }
}
export interface Input1 {
  feature_premium: any;
  tyre_type: any;
  deck_length: any;
  color: any;
  deck_type: any;
  no_seats: any;
  brand: any;
  air_conditioning: any;
  cabin_type: any;
  wheels: any;
  fuel_type: any;
  body_type: any;
  roof_type: any;
  sleeping_option: any;
  body_option: any;
  tonnage: any;
  engine_power: any;
  body_size: any;
  suspension_type: any;
  engine_type: any;
  colour: any;
  ventilation: any;
  wheelbase: any;
  payload: any;
  wheel_drive: any;
  engine: any;
  RMC_Drum_Size: any;
}
